import React, { useEffect, useState } from 'react'
import './NumberBlock.scss'


const NumberBlock = ({defaultValue, name, register, setFormValue, errors = {}}) => {
    const [number, setNumber] = useState(Number(defaultValue));

    useEffect(()=>{
        setFormValue(name, number);
    },[number])

    return (
        <>
            <div className="number-block">
                <div className="input-group">
                    <button className="btn btn-decrement" type="button" onClick={() => setNumber(number > 0 ? number-1 : 0)}>-</button>
                    <input className="num" type="number" {...register} value={number} readOnly={false} minLength={0} maxLength={4} onChange={v => {setNumber(Number(v.target.value) > 0 ? Number(v.target.value) : 0)}} />
                    <button className="btn btn-increment" type="button" onClick={() => setNumber(number+1)}>+</button>
                </div>
            </div>
            {(errors && errors[name]) && (<span className="error">{errors[name].message}</span>)}
        </>
    )
}

export default NumberBlock